export enum PluginType {
  None = 0,
  WebFleet = 1
}
